<div class="flex flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-description
        [form]="deliverableForm()"
        [creatorId]="executionAnalytics()?.creatorId"
        [isCustomMode]="true"
        [creators]="[]"
        [isViewMode]="true"
        [isExpanded]="true"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible && contentData()?.description) {
    <div class="flex flex-col gap-3">
      <h3 class="text-sm font-bold">
        {{ 'pages.campaignDetails.ctaAnalytics.details.detected' | translate }}
        {{ 'pages.campaignDetails.ctaAnalytics.deliverable.' + deliverableType + '.title' | translate | lowercase }}
      </h3>
      <p class="text-lg" [innerHTML]="highlightKeywords(contentData()?.description ?? '')"></p>
    </div>
  }
</div>
